import * as React from 'react';
import Button from '@material-ui/core/Button';
import { DataGrid } from '@material-ui/data-grid';
import { makeStyles } from '@material-ui/core/styles';
import { history } from '../../components/helpers/History';
import PropTypes from 'prop-types';
import { useSelector } from "react-redux";
import {USER_ROLE} from '../../components/security/UserRole';

const useStyles = makeStyles({
  root: {
    '& .super-app-theme--header': {
      backgroundColor: '#c6c4cc',
    },
  },
});
const columns = [
  { field: 'sNo', headerName: 'S.No.' , width : 150, headerClassName: 'super-app-theme--header'},
  { field: 'firstName', headerName: 'First Name' , width : 150, headerClassName: 'super-app-theme--header'},
  { field: 'lastName', headerName: 'Last Name' , width : 150, headerClassName: 'super-app-theme--header'},
  { field: 'email', headerName: 'Email' , width : 150, headerClassName: 'super-app-theme--header'},
  { field: 'status', headerName: 'Status' , width : 100, headerClassName: 'super-app-theme--header'},
  { field: 'hospitalId', headerName: 'Hospital Name' , width : 150, headerClassName: 'super-app-theme--header'},
  // { field: 'specialist', headerName: 'Speialist' , width : 150, headerClassName: 'super-app-theme--header'},
  {
    field: 'id',
    headerName: 'Action',
    width: 150,
    headerClassName: 'super-app-theme--header',
    headerAlign: 'center',
    renderCell: (params) => (
        <Button
          variant="contained"
          color="primary"
          size="small"
          style={{ marginLeft: 16 }}
          onClick={ () => {
            console.log(params.value);
            history.push(`/doctor/edit/${params.value}`);
          }}
        >
          Edit
        </Button>
      
    ),
  },
];

const passwordButtonColumn = (
  {
    field: 'userId',
    headerName: 'Update Password',
    width: 150,
    headerClassName: 'super-app-theme--header',
    headerAlign: 'center',
    renderCell: (params) => (
      <>
        <Button
          variant="contained"
          color="primary"
          size="small"
          style={{ marginLeft: 16 }}
          onClick={ () => {
            history.push(`change-password/${params.value}`);
          }}
        >
          Password
        </Button>
        
        
        </>
      
    ),
  }
);
  
const DoctorRecordList = ({ doctorList, ...rest }) => {
  const classes = useStyles();
  let rows = [];
  const user = useSelector((state) => state.authentication.user);
  if(doctorList && doctorList.length > 0){
    doctorList.forEach((element,index) => {
      var newElement = {...element};
      newElement.sNo = index+1;
      rows.push(newElement);
    });
  }else{
    rows = [];
  }
  if(user.userRole === USER_ROLE.SYSTEM_ADMIN){
    columns.push(passwordButtonColumn);
  }
  return (
    <div style={{ height: 500, width: '100%' }} className={classes.root}>
      <DataGrid  pageSize={10} rowsPerPageOptions={[10, 25, 50,100]} pagination rows={rows} columns={columns} />
      {/* {disableColumnMenu} */}
    </div>
  );
}
DoctorRecordList.propTypes = {
  doctorList: PropTypes.array.isRequired
};

export default DoctorRecordList;
